export default {
	unifi_integration: {
		site_preparation: {
			steps: {
				unknown: 'Unbekannter Schritt',
				purgeWirelessNetworks: 'Bestehende WiFi SSIDs löschen',
				purgeNetworks: 'Bestehende VLANs löschen',
				purgeFixedIps: 'Bestehende feste IPs löschen',
				resetAccessPointConfigurations: 'AP-Konfigurationen zurücksetzen',
				enableWanDhcp: 'DHCP auf WAN für bestehende Router aktivieren',
				setDefaultVlans: 'Standard-VLANs setzen',
				setFixedIps: 'Feste IPs setzen',
				ensureDefaultSsidExists: 'Standard WiFi SSID sicherstellen',
			},
		},
		device_move: {
			in_site: 'in Site',
			last_seen: 'Zuletzt gesehen: {date} (vor {days} Tagen, {hours} Stunden)',
			last_seen_unknown: 'Zuletzt gesehen: unbekannt',
			move_to_site: 'Verschieben nach Site',
			select_site: 'Site auswählen ...',
			move_device: 'Gerät verschieben',
			moved_message: '{device} verschoben von Site {from} zur Site {to}',
			blocked_reason:
				'Dieses Gerät befindet sich nicht in der Default Site (aktuell "{site}") und kann daher nicht verschoben werden.',
			override_reasons: {
				long_offline: 'Dieses Gerät ist schon lange offline und kann daher trotzdem verschoben werden.',
				unknown_last_seen:
					'Für dieses Gerät liegt kein "zuletzt gesehen" Datum vor, es kann daher trotzdem verschoben werden.',
			},
			confirm: {
				title: 'Gerät verschieben?',
				body: 'Soll das Gerät "{device}" wirklich zur Site "{site}" verschoben werden?',
			},
			toasts: {
				moved: {
					title: 'Gerät verschoben',
					body: 'Gerät "{device}" wurde zur Site "{site}" verschoben',
				},
				move_failed: {
					title: 'Verschieben fehlgeschlagen',
					body: 'Gerät "{device}" konnte nicht verschoben werden',
				},
			},
		},
	},
};
